import axios from "axios";
import moment from "moment";
import { Formik } from "formik";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import { Col, Row, Input, Button, Form, Label } from "reactstrap";
import { Redirect, useHistory, useParams, useLocation } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import { ReviewLeaveApplication_API } from "./ReviewLeaveApplication_API";
import { AlertPopups } from "../../../components/AlertPopups";
import { Config, Routes } from "../../../configurations/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import FormStatus from "../../../components/FormStatus";

function ReviewLeaveApplicationDetail() {
	let token,
		empRole = null;
	const { id } = useParams();
	const history = useHistory();
	const location = useLocation();
	const [isFutureLeave, setIsFutureLeave] = useState(false);
	const [itemStatus, setItemStatus] = useState(null);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [attachedFileName, setAttachedFileName] = useState("");
	const [reviewLeaveDetailData, setReviewLeaveDetailData] = useState({});

	const initialValues = {
		supervisorComments: "",
	};
	const [formFields, setFormFields] = useState(initialValues);
	const validate = Yup.object().shape({
		supervisorComments: Yup.string()
			.required("Comments is Required")
			.max(500, "Max 500 characters allowed")
			.nullable(),
	});

	useEffect(() => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${ReviewLeaveApplication_API.GetUnreviewedLeavesApplicationDetail}/${id}`,
				{
					headers: tokenHeader,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					if (empRole.includes("3")) setItemStatus(data.adminStatus);
					else setItemStatus(data.supervisorStatus);

					setReviewLeaveDetailData(data);
					const currentDate = new Date();
					const startDate = new Date(data.startDate);
					const endDate = new Date(data.endDate);
		  
					setIsFutureLeave(
					  currentDate.getDate() === startDate.getDate() ||
					  (currentDate > startDate && currentDate > endDate)
					);
					setAttachedFileName(data.attachmentFile);
				}
			});
		setApiHeaderToken(tokenHeader);
	}, [empRole, id, token]);

	const handleApprove = () => {
		const startDate = new Date(reviewLeaveDetailData.startDate);
		const endDate = new Date(reviewLeaveDetailData.endDate);

		if (
			(new Date().getDate() === startDate.getDate() ||
				new Date() > startDate) &&
			new Date() > endDate
		) {
			reviewLeaveApplication(3);
		} else {
			AlertPopups.confirmBox
				.fire({
					text: "Are you sure you want to approve this future leave?",
				})
				.then((result) => {
					if (result.value) {
						reviewLeaveApplication(3);
					}
				});
		}
	};
	const handleSubmit = () => {
		reviewLeaveApplication(2);
	};
	const getImageByStatus = (status) => {
		switch (status.toLowerCase()) {
			case "approved":
				return (
					<img
						title="Approved"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/approved.jpg"
					/>
				);
			case "rejected":
				return (
					<img
						title="Rejected"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/rejected.png"
					/>
				);
			case "invalid":
				return (
					<img
						title="Invalid"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/invalid.png"
					/>
				);
			default:
				return (
					<img
						title="Pending"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/pending.png"
					/>
				);
		}
	};
	const reviewLeaveApplication = (approvalStatus) => {
		if (approvalStatus === 2 && !formFields.supervisorComments) {
			AlertPopups.ErrorAlert.fire({
				text: "Supervisor comments are required for rejection.",
			});
			return; // Exit the function if supervisor comments are missing for rejection
		}
		const formBody = {
			supervisorComments: formFields.supervisorComments,
			approvalStatus: approvalStatus,
		};

		if (approvalStatus === 2 && !formFields.supervisorComments) {
			AlertPopups.ErrorAlert.fire({
				text: "Supervisor comments are required for rejection.",
			});
			return; // Exit the function if supervisor comments are missing for rejection
		}
		
		axios
			.patch(
				`${ReviewLeaveApplication_API.PatchReviewLeaveApplication}/${id}`,
				formBody,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Application Reviewed",
					});
					history.push(Routes.SpReviewLeave);
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<FormStatus
								id={id}
								title="Review Leave Application Detail"
								formStatus={itemStatus}
								className="create-request d-flex align-items-center"
								onClick={() => {
									history.push(Routes.SpReviewLeave);
								}}
								navigateBack={true}
							/>

							<div className="formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>
										View Leave Application
									</Label>
								</div>
								<Col>
									<Row className="py-2 px-2">
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Name</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.employeeName
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Application ID</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.applicationId
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Type</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveType
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Applied Date</div>
											</div>
										</Col>
										<Col md={3} lg={3}>
											<p className="formValueContainer">
												{reviewLeaveDetailData.appliedDate &&
													moment(
														reviewLeaveDetailData.appliedDate
													).format("DD/MM/YYYY ")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Start Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{reviewLeaveDetailData.startDate &&
													moment(
														reviewLeaveDetailData.startDate
													).format("DD/MM/YYYY ")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>End Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{reviewLeaveDetailData.endDate &&
													moment(
														reviewLeaveDetailData.endDate
													).format("DD/MM/YYYY ")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Duration</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveDuration
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Attachment</div>
											</div>
										</Col>
										<Col
											md={12}
											lg={3}
											id="attachment-align"
										>
											{attachedFileName ? (
												<p className="formValueContainer">
													<FontAwesomeIcon
														icon={faPaperclip}
														size="1x"
														color="black"
														className="formValueContainer"
													/>
													<a
														href={`${Config.server_url}/${attachedFileName}`}
														target="_blank"
														rel="noopener noreferrer"
														id="attLink"
														class="formValueContainer"
													>
														{attachedFileName &&
															attachedFileName}
													</a>
												</p>
											) : (
												<p className="formValueContainer">
													None
												</p>
											)}
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Reason</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveReasons
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee's Comments</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.employeeComments
												}
											</p>
										</Col>
									</Row>
								</Col>
							</div>

							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Leave Balance</Label>
								</div>

								<Row className="py-2 px-4">
									<Col sm={2} md={2} lg={2}>
										<div className="formDetailHeader">
											<div>Annual</div>
										</div>
									</Col>
									<Col sm={1} md={1} lg={2}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.annualLeaveBalance
											}
										</p>
									</Col>
									<Col sm={1} md={1} lg={2}>
										<div className="formDetailHeader">
											<div>Sick</div>
										</div>
									</Col>
									<Col sm={1} md={1} lg={2}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.sickLeaveBalance
											}
										</p>
									</Col>
									<Col sm={3} md={3} lg={2}>
										<div className="formDetailHeader">
											<div>Compensation</div>
										</div>
									</Col>
									<Col sm={2} md={2} lg={2}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.compensationLeaveBalance
											}
										</p>
									</Col>
								</Row>
							</div>
							{userDetails.empRole.includes("3") && ( //admin
								<div className=" my-4 formInfoContainer">
									<div className="formInfoContainerHeader">
										<Label sm={12}>Supervisor Status</Label>
									</div>
									<Row className="py-2 px-3">
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Approvers
												</div>
											</Row>
											<p className="px-2 formValueContainer">
												{
													reviewLeaveDetailData.supervisorName
												}
											</p>
										</Col>
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Application Status
												</div>
											</Row>
											<div className="px-5 formDetailHeader">
												<p className="formValueContainer">
													{reviewLeaveDetailData.supervisorStatus
														? getImageByStatus(
																reviewLeaveDetailData.supervisorStatus
														  )
														: null}
												</p>
											</div>
										</Col>
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Comments
												</div>
											</Row>
											<div className="px-2 mr-5">
												<Input
													type="textarea"
													name="supComments"
													disabled={true}
													className="supDesciptionBox"
													value={
														reviewLeaveDetailData.supervisorComments
													}
												/>
											</div>
										</Col>
										<Col lg={3}>
											<Row>
												<div className="px-4 formDetailHeader">
													Last Updated Date
												</div>
											</Row>
											<p className="px-2 formValueContainer">
												{reviewLeaveDetailData.supervisorLastTimeUpdated
													? moment(
															reviewLeaveDetailData.supervisorLastTimeUpdated
													  ).format(
															"DD/MM/YYYY HH:mm"
													  )
													: null}
											</p>
										</Col>
									</Row>
								</div>
							)}
							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>
										Review Leave Application
									</Label>
								</div>
								<Formik
									enableReinitialize={true}
									initialValues={formFields}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<Form>
											<Row className="py-2">
												<Col lg={3}>
													<div className="px-4 formDetailHeader">
														<div>Reviewer Name</div>
													</div>
												</Col>
												<Col lg={3}>
													<p className="formValueContainer">
														{
															reviewLeaveDetailData.reviewerName
														}
													</p>
												</Col>
												<Col lg={2}>
													<div className="px-4 formDetailHeader">
														<div>Comments</div>
													</div>
												</Col>
												<Col lg={4}>
													<div className="px-4 formDetailHeader">
														<Input
															type="textarea"
															name="supervisorComments"
															className={`supDesciptionBox ${
																errors.supervisorComments
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															onChange={(event) =>
																setFormFields({
																	supervisorComments:
																		event
																			.target
																			.value,
																})
															}
															readOnly={
																itemStatus !=
																"Pending"
															}
															value={
																formFields.supervisorComments
															}
															maxLength="400"
														/>
													</div>
												</Col>
											</Row>
										</Form>
									)}
								</Formik>
							</div>
							<Row
								className={`px-3 ${
									!isFutureLeave
										? "justify-content-between"
										: "float-right"
								} `}
							>
								{!isFutureLeave ? (
									<div className="leaveNote pb-3">
										<b>Note:</b> This is a future date
										leave, you can't approve before
										the leave date.
									</div>
								) : null}

								<div className="pt-1">
									<Button
										className="delete-btn leftBtn"
										onClick={handleSubmit}
									
									>
										Reject
									</Button>
									<Button
										className="approve-btn"
										onClick={handleApprove}
										disabled={!isFutureLeave}
									>
										Approve
									</Button>
								</div>
							</Row>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ReviewLeaveApplicationDetail;
